/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {VendorListView} from "../../vendor/views/VendorListView";
const route = [{webpackEntry: "vendorList", path: [rpAppPath.vendor.list, rpAppPath.vendor.friendlyVendorList], component: VendorListView}];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {VendorListView} from "../../vendor/views/VendorListView";
const route = [{webpackEntry: "vendorList", path: [rpAppPath.vendor.list, rpAppPath.vendor.friendlyVendorList], component: VendorListView}];

(function () {
    rpClient(route);
})();
